import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql,useApolloClient } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
//import ThemeContext from "../../context/ThemeContext";
import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from "../../../../../context/UserContext";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { Link, useNavigate } from "react-router-dom";
import { TabView, TabPanel } from 'primereact/tabview';
import { RadioButton } from "primereact/radiobutton";
import { Fieldset } from 'primereact/fieldset';
import { Divider } from 'primereact/divider';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { PrimeReactProvider } from "primereact/api";
import { Dialog } from 'primereact/dialog';
//import HtlAgnSeaReduction from "./HtlAgnSeaReduction";
//import HtlAgnSeasonPriceEdit from "./HtlAgnSeasonPriceEdit";
import HtlAgnOffresEdit from "../../../hoteladm/hotel/offers/HtlAgnOffresEdit";
import HtlAgnOffresGrp from "../../../hoteladm/hotel/offers/HtlAgnOffres";
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputSwitch } from "primereact/inputswitch";






import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';

const GET_POST = gql`
  query MyQuery12(
    $firmMainCode: String
    $firmSubCode: String
    $currentLocale: String
    $contIdSeq: Int!

  ) {
    tbl_cont_rules_def(
      order_by: { firm_main_code: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        cont_id: { _eq: $contIdSeq }
        
      }
    ) {
      firm_main_code
      firm_sub_code
      id_seq
      cont_id
      rules_grp_id
      rules_class
      rules_type
      rules_name
      rules_grp_class
    }
  }
`;


const GET_PRICE_LIST = gql`
  query GetRuleSub(
    $firmMainCode: String, 
    $firmSubCode: String,
    $contIdSeq: Int,
    $startDate3: date,
    $endDate3: date,
    $adl: Int
  ) {
    tbl_cont_per_price(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq },
      
        price_date: { _gte: $startDate3, _lte: $endDate3 }       
      },
      order_by: { r_type_code: asc, price_date: asc } 
    ) {   
        cont_id         
        r_type_code
        get_room_name {
          r_type_name
          }
        per_price
        base_price
        currency
        red_id
        price_date
        adult
        child
    }
  }
`;

//get base price 

const GET_PRICE_LIST_BASE = gql`
  query GetRuleSub(
    $firmMainCode: String, 
    $firmSubCode: String,
    $contIdSeq: Int,
    $startDate3: date,
    $endDate3: date,
    $adl: Int
  ) {
    tbl_cont_per_price(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq },
        adult: { _eq: 1 },
      
        price_date: { _gte: $startDate3, _lte: $endDate3 }       
      },
      order_by: { r_type_code: asc, price_date: asc } 
    ) {   
        cont_id         
        r_type_code
        get_room_name {
          r_type_name
          }
        per_price
        base_price
        red_id
        currency
        price_date
        adult
        child
    }
  }
`;

const GET_HTL_ROOM = gql`
  query GetHtlSea(
    $firmMainCode: String
    $firmSubCode: String
   
    
  ) {
    tbl_htl_room_type(order_by: { r_type_code: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
       
       
      }
    ) {
     
        r_type_code
        r_type_name
        
       
    }
  }
`;






const UPDATE_BASE_PRICE = gql`
  mutation UpdateContBasePrice(
    $contIdSeq: Int
    $firmMainCode: String
    $firmSubCode: String
    $basePricePersent: float8
    $rTypeCodeSelect: String
    $startDate: date
    $endDate: date
    $newPerPrice: float8
    $adl: Int
  ) {
    update_tbl_cont_per_price(
      where: {
        firm_main_code: { _eq: $firmMainCode },
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq },   
        r_type_code: { _eq: $rTypeCodeSelect },
        adult: { _eq: $adl },
        price_date: { _gte: $startDate, _lte: $endDate },   
      },
      _set: {
        per_price: $newPerPrice
      }
    ) {
      affected_rows
    }
  }
`;

const UPDATE_BASE_PRICE2 = gql`
  mutation UpdateContBasePrice(
    $contIdSeq: Int
    $firmMainCode: String
    $firmSubCode: String
    $basePricePersent: float8
    $rTypeCodeSelect: String
    $startDate: date
    $endDate: date
    $newPerPrice: float8
    $adl: Int
  ) {
    update_tbl_cont_per_price(
      where: {
        firm_main_code: { _eq: $firmMainCode },
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq },   
        r_type_code: { _eq: $rTypeCodeSelect },
        adult: { _eq: 1 },
        price_date: { _gte: $startDate, _lte: $endDate },  

      },
      _set: {
        per_price: $basePricePersent
      }
    ) {
      affected_rows
    }
  }
`;









const BATCH_UPDATE_CONT_BASE_PRICE = gql`
  mutation InsertPrice($records: [tbl_cont_per_price_insert_input!]!) {
    insert_tbl_cont_per_price(objects: $records) {
      affected_rows
    }
  }
`;


const UPDATE_CONT_BASE_PRICES_MUTATION = gql`
mutation updateContBasePrices(
  $firmMainCode: String!,
  $firmSubCode: String!,
  $contIdSeq: Int!,
  $rTypeCodeSelect: String!,
  $startDate: String!,
  $endDate: String!,
  $newPerPrice: Float!
) {
  updateContBasePrices(
    where: {
      firm_main_code: { _eq: $firmMainCode },
      firm_sub_code: { _eq: $firmSubCode },
      cont_id: { _eq: $contIdSeq },
      r_type_code: { _eq: $rTypeCodeSelect },
      price_date: { _gte: $startDate, _lte: $endDate },
    },
    data: {
     
      per_price: { _set: $newPerPrice },
    }
  ) {
    success
    message
    affected_rows
  }
}
`;

const typeDefs = gql`
  input tbl_cont_per_price_set_input {
    per_price: Float!
    where: tbl_cont_per_price_bool_exp!
  }

  input tbl_cont_per_price_bool_exp {
    firm_main_code: String_comparison_exp!
    firm_sub_code: String_comparison_exp!
    cont_id: Int_comparison_exp!
    r_type_code: String_comparison_exp!
    adult: Int_comparison_exp!
    price_date: Date_comparison_exp!
  }

  input tbl_cont_per_price_where_unique_input {
    firm_main_code: String!
    firm_sub_code: String!
    cont_id: Int!
    r_type_code: String!
    adult: Int!
    price_date: Date!
  }
`;

const GET_PRICE_DETAIL_DATA = gql`
  query GetCurrentData(
    $firmMainCode: String, 
    $firmSubCode: String,
    $contIdSeq: Int,
    $detailDateQ: date,
    $detailAdultQ: Int,
    $detailChildQ: Int,
   
    $rTypeCodeQ: String,
   
  ) {
    tbl_cont_per_price(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq },
        r_type_code: { _eq: $rTypeCodeQ },
        price_date: { _eq: $detailDateQ},
        adult: { _eq: $detailAdultQ},

       
      },
      order_by: { price_date: asc } 
    ) {   
        cont_id         
        r_type_code
        per_price
        base_price
        currency
        price_date
        firm_main_code
        firm_sub_code
        adult
        child
        person_factor
        week_rule_action_value
        sepecial_day_action_value
        dyn_price_value
        get_room_name {
          base_price_persent
          }
    }
  }
`;















const HtlSalesPlanCalc = () => {
    const { users } = useContext(UserContext);
    const { firmcode, subfirmcode, usertype, userLang } = users;
    const { id_seq } = useParams();
    const {varCode3, setVarCode3} = useContext(ThemeContext);
    const {varCode4, setVarCode4} = useContext(ThemeContext);
    const {varCode5, setVarCode5} = useContext(ThemeContext);
    const {varCode6, setVarCode6} = useContext(ThemeContext);
    const {varCode7, setVarCode7} = useContext(ThemeContext);
    const {varCode8, setVarCode8} = useContext(ThemeContext);
    const [someCondition, setSomeCondition] = useState(false);

    const {varCode, setVarCode} = useContext(ThemeContext);
    
    const {varCode9, setVarCode9} = useContext(ThemeContext);
    const {varCode10, setVarCode10} = useContext(ThemeContext);
    const {varCode11, setVarCode11} = useContext(ThemeContext);
    const {varCode12, setVarCode12} = useContext(ThemeContext);
    const {varCode14, setVarCode14} = useContext(ThemeContext);
   
    
    const firmMainCode = firmcode;
    const firmSubCode = subfirmcode;
    const intl = useIntl();
    const currentLocale = userLang || localStorage.getItem('lang') || 'en';
  
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(0);
    const [activeTabS, setActiveTabS] = useState(9);
  
    const handleTabChange = (index) => {
      setActiveTab(index);
    };
  
    const handleTabChangeS = (index) => {
      setActiveTabS(index);
    };
  
    const { loading, error, data, refetch } = useQuery(GET_POST, {
      variables: { firmSubCode, firmMainCode, contIdSeq: varCode4 },
    });

    const [detailDateQ, setDetailDateQ] = useState(new Date());
    const [rTypeCodeQ, setRTypeCodeQ] = useState("FAR");
    const [detailAdultQ, setDetailAdultQ] = useState(2);
    const [detailChildQ, setDetailChildQ] = useState(0);
    const localdetalilDate = new Date(detailDateQ);
  

    const { loading: loadingPriceDtl, error: PriceDtlError, data: PriceDtlData, refetch: refetchPriceDtl} = useQuery(GET_PRICE_DETAIL_DATA, {
      variables: { 
          firmMainCode, 
          firmSubCode, 
          contIdSeq: varCode4, 
          detailDateQ: detailDateQ,      
          rTypeCodeQ: rTypeCodeQ,
          detailAdultQ: detailAdultQ,
          
          
         
      },
      fetchPolicy: 'network-only', 
    });



    
 
  
  
    const firmData = data && data.tbl_cont_rules_def ? data.tbl_cont_rules_def[0] : null;

    const tblGetPriceDetail = PriceDtlData && PriceDtlData.tbl_cont_per_price ? PriceDtlData.tbl_cont_per_price[0] : null ;

    const [contIdSeq, setContIdSeq] = useState(firmData ? firmData.cont_id :"");
    const [contSeaIdSeq, setContSeaIdSeq] = useState(firmData ? firmData.id_seq :"");
    const [htlSeaIdSeq, setHtlSeaIdSeq] = useState(firmData ? firmData.rules_grp_id :"");

    const [contRuleId, setContRuleId] = useState(firmData ? firmData.id_seq :"");
    const [htlRuleId, setHtlRuleId] = useState(firmData ? firmData.rules_grp_id :"");
    const [rulesGrpClass, setRulesGrpClass] = useState(firmData ? firmData.rules_grp_class :"");
    
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [rTypeCodeSelect, setRTypeCodeSelect] = useState("");
    const [startDate3, setStartDate3] = useState(new Date().toLocaleDateString());
    const [endDate3, setEndDate3] = useState(new Date().toLocaleDateString());
    const [basePricePersent, setBasePricePersent] = useState(null);
    const [basePrice, setBasePrice] = useState(null);
    const [allPrice, setAllPrice] = useState(true);
    const [allRoom, setAllRoom] = useState(true);
    const [weekRule, setWeekRole] = useState(false);
    const [specialRule, setSpecialRole] = useState(false);


const [detalilDate, setDetailDate] = useState(PriceDtlData ? new Date(PriceDtlData.per_date): new Date());
const [rTypeCode, setRTypeCode] = useState(PriceDtlData ? PriceDtlData.r_type_code :"");
const [detailAdult, setDetailAdult] = useState(PriceDtlData ? PriceDtlData.adult :0);
const [detailChild, setDetailChild] = useState(PriceDtlData ? PriceDtlData.child :0);
const [detailPrice, setDetailPrice] = useState(PriceDtlData ? PriceDtlData.per_price :0);
const [detailCurrency, setDetailCurrency] = useState(PriceDtlData ? PriceDtlData.currency :"");
const [detailBasePrice, setDetailBasePrice] = useState(PriceDtlData ? PriceDtlData.base_price :0);
const [detailPersonFactor, setPersonFactor] = useState(PriceDtlData ? PriceDtlData.person_factor :0);
const [detailWeekFactor, setDetailWeekFactor] = useState(PriceDtlData ? PriceDtlData.week_rule_action_value :0);
const [detaiSlpecialFactor, setdetailSpecialFactor] = useState(PriceDtlData ? PriceDtlData.sepecial_day_action_value :0);
const [detailRoomFactor, setDetailRoomFactor] = useState(PriceDtlData ? PriceDtlData.tbl_cont_per_price[0]?.get_room_name?.base_price_persent : 0);
const [detailDynFactor, setDetailDynFactor] = useState(PriceDtlData ? PriceDtlData.dyn_price_value : 0);

useEffect(() => {
  refetchPriceDtl();
}, [detailAdultQ]);
  


useEffect(() => {
  if (tblGetPriceDetail) {  
   
    setDetailDate(new Date(tblGetPriceDetail.price_date));
    setRTypeCode(tblGetPriceDetail.r_type_code);
    setDetailAdult(tblGetPriceDetail.adult);
    setDetailChild(tblGetPriceDetail.child);
    setDetailPrice(tblGetPriceDetail.per_price);
    setDetailCurrency(tblGetPriceDetail.currency);
    setDetailBasePrice(tblGetPriceDetail.base_price);
    setPersonFactor(tblGetPriceDetail.person_factor);   
    setDetailWeekFactor(tblGetPriceDetail.week_rule_action_value !== null ? tblGetPriceDetail.week_rule_action_value : 0);
    setdetailSpecialFactor(tblGetPriceDetail.sepecial_day_action_value !== null ? tblGetPriceDetail.sepecial_day_action_value : 0);
    setDetailDynFactor(tblGetPriceDetail.dyn_price_value !== null ? tblGetPriceDetail.dyn_price_value : 0);
    setDetailRoomFactor(PriceDtlData ? PriceDtlData.tbl_cont_per_price[0]?.get_room_name?.base_price_persent : 0);

    console.log('test data:', tblGetPriceDetail);
  }
}, [tblGetPriceDetail]);


   






const GET_CURRENT_DATA = gql`
  query GetCurrentData(
    $firmMainCode: String, 
    $firmSubCode: String,
    $contIdSeq: Int,
    $startDate: date,
    $endDate: date,
    $rTypeCodeSelect: String,
    $allRoom: Boolean
  ) {
    tbl_cont_per_price(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq },
        price_date: { _gte: $startDate, _lte: $endDate },
        ${allRoom ? '' : `r_type_code: { _eq: $rTypeCodeSelect },`}
      },
      order_by: { price_date: asc } 
    ) {   
        cont_id         
        r_type_code
        per_price
        base_price
        currency
        price_date
        firm_main_code
        firm_sub_code
        adult
        person_factor
        week_rule_action_value
        sepecial_day_action_value
        get_room_name {
          base_price_persent
          }
    }
  }
`;



   
  
   const detail = messages[currentLocale].detail;
   const activerec = messages[currentLocale].activerec;
   const inactiverec = messages[currentLocale].inactiverec;
    
   const localStartDate = new Date(startDate);
   const localEndDate = new Date(endDate);
   
   
   const { loading: loadingRuleSub2, error: perRuleSubError2, data: perRuleSubData2, refetch: refetchRuleSub2} = useQuery(GET_CURRENT_DATA, {
    variables: { 
        firmMainCode, 
        firmSubCode, 
        contIdSeq: varCode4, 
        startDate: localStartDate.toLocaleDateString(),
        endDate: localEndDate.toLocaleDateString(),
        rTypeCodeSelect,
        allRoom
    },
    fetchPolicy: 'network-only', 
});








const { loading: htlRuleLoading, error: htlRuleError, data: htlRuleData, refetch: refetcGetHtlRule } = useQuery(GET_HTL_ROOM, {
        variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode },
      });



      const { loading: loadingRuleSub, error: perRuleSubError, data: perRuleSubData, refetch: refetchRuleSub } = useQuery(GET_PRICE_LIST, {
        variables: { firmMainCode, firmSubCode, contIdSeq: varCode4, startDate3: startDate3, endDate3: endDate3},
    });
    const tblContPerPrice = perRuleSubData && perRuleSubData.tbl_cont_per_price ? perRuleSubData.tbl_cont_per_price : [];

    const { loading: loadingRuleSub22, error: perRuleSubError22, data: perRuleSubData22, refetch: refetchRuleSub22 } = useQuery(GET_PRICE_LIST_BASE, {
      variables: { firmMainCode, firmSubCode, contIdSeq: varCode4, startDate3: startDate3, endDate3: endDate3},
  });
  const tblContPerPrice22 = perRuleSubData22 && perRuleSubData22.tbl_cont_per_price ? perRuleSubData22.tbl_cont_per_price : [];

    /*
    // Tüm tarihleri al
    const dates = [...new Set(tblContPerPrice.map(item => item.price_date))];

    

     const formattedDates = tblContPerPrice.map(item => {
    const [year, month, day] = item.price_date.split('-');
    return `${day} ${month}`;
  });
  
    const groupedData = {};
    tblContPerPrice.forEach(item => {
      if (!groupedData[item.r_type_code]) {
        groupedData[item.r_type_code] = { r_type_code: item.r_type_code }; // ROOM TYPE verisini ekledik
      }
      groupedData[item.r_type_code][item.price_date] = item.per_price;
    }); */

  /*  const extractDates = (data) => {
        return [...new Set(data.map(item => {
            const date = new Date(item.price_date);
            return date.toLocaleDateString('en-GB'); // İngiliz (Birleşik Krallık) yerel ayarlarına göre tarih biçimlendirmesi
        }))];
    }; */

  /*  const extractDates = (data) => {
        return [...new Set(data.map(item => {
            const date = new Date(item.price_date);
            const formattedDate = `${date.getDate()} ${getMonthName(date.getMonth())} ${date.getFullYear()}`;
            return formattedDate;
        }))];
    };
    
    // Ay ismini almak için kullanılacak yardımcı fonksiyon
    const getMonthName = (monthIndex) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return months[monthIndex];
    };


  
  const dates = extractDates(tblContPerPrice);

  const groupedData = {};
tblContPerPrice.forEach(item => {
    if (!groupedData[item.r_type_code]) {
        groupedData[item.r_type_code] = { r_type_code: item.r_type_code }; // ROOM TYPE verisini ekledik
    }
    const date = new Date(item.price_date);
    const formattedDate = `${date.getDate()} ${getMonthName(date.getMonth())} ${date.getFullYear()}`; // Tarihi belirli bir formata dönüştürme
    groupedData[item.r_type_code][formattedDate] = item.per_price;
});*/

const getMonthNameTR = (monthIndex) => {
    const months = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];
    return months[monthIndex];
};

const getMonthNameEN = (monthIndex) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[monthIndex];
};

const extractDatesTR = (data) => {
    return [...new Set(data.map(item => {
        const date = new Date(item.price_date);
        const formattedDate = `${date.getDate()} ${getMonthNameTR(date.getMonth())} ${date.getFullYear()}`;
        return formattedDate;
    }))];
};

const extractDatesEN = (data) => {
    return [...new Set(data.map(item => {
        const date = new Date(item.price_date);
        const formattedDate = `${date.getDate()} ${getMonthNameEN(date.getMonth())} ${date.getFullYear()}`;
        return formattedDate;
    }))];
};

const extractDates = (currentLocale === 'trr') ? extractDatesTR : extractDatesEN;

const getMonthName = (currentLocale === 'trr') ? getMonthNameTR : getMonthNameEN;

const dates = extractDates(tblContPerPrice);

const dates22 = extractDates(tblContPerPrice22);

/* price yuvarlama oncesi

const groupedData = {};
tblContPerPrice.forEach(item => {
    if (!groupedData[item.r_type_code]) {
        groupedData[item.r_type_code] = { r_type_code: item.r_type_code };
    }
    const date = new Date(item.price_date);
    const formattedDate = `${date.getDate()} ${getMonthName(date.getMonth())} ${date.getFullYear()}`;
    groupedData[item.r_type_code][formattedDate] = item.per_price;
});
*/

/* ondalik sayiyi 2 olarak goster

const groupedData = {};
tblContPerPrice.forEach(item => {
    if (!groupedData[item.r_type_code]) {
        groupedData[item.r_type_code] = { r_type_code: item.r_type_code };
    }
    const date = new Date(item.price_date);
    const formattedDate = `${date.getDate()} ${getMonthName(date.getMonth())} ${date.getFullYear()}`;
    // per_price alanını yuvarla ve sadece iki ondalık hane göster
    const roundedPerPrice = parseFloat(item.per_price).toFixed(2);
    groupedData[item.r_type_code][formattedDate] = roundedPerPrice;
});

*/



// tam sayi olarak goster

const groupedData22 = {};
tblContPerPrice22.forEach(item => {
    if (!groupedData22[item.r_type_code]) {
        // Eğer gruplanmış veri yoksa yeni bir grup oluştur
        groupedData22[item.r_type_code] = {
            r_type_code: item.r_type_code,
           
            r_type_name: item.get_room_name?.r_type_name, // Eğer varsa oda adını al
        };
    }
    const date = new Date(item.price_date);
    const formattedDate = `${date.getDate()} ${getMonthName(date.getMonth())} ${date.getFullYear()}`;
    // per_price alanını tam sayıya yuvarla
    const roundedPerPrice = Math.round(parseFloat(item.base_price));
    groupedData22[item.r_type_code][formattedDate] = roundedPerPrice;
    
}); 

const groupedData11 = {};
tblContPerPrice22.forEach(item => {
    if (!groupedData11[item.r_type_code]) {
        // Eğer gruplanmış veri yoksa yeni bir grup oluştur
        groupedData11[item.r_type_code] = {
            r_type_code: item.r_type_code,
           
            r_type_name: item.get_room_name?.r_type_name, // Eğer varsa oda adını al
        };
    }
    const date = new Date(item.price_date);
    const formattedDate = `${date.getDate()} ${getMonthName(date.getMonth())} ${date.getFullYear()}`;
    // per_price alanını tam sayıya yuvarla
    const roundedPerPrice = Math.round(parseFloat(item.per_price));
    groupedData11[item.r_type_code][formattedDate] = roundedPerPrice;
    
}); 

const groupedData = {};
tblContPerPrice.forEach(item => {
    if (!groupedData[item.r_type_code]) {
        // Eğer gruplanmış veri yoksa yeni bir grup oluştur
        groupedData[item.r_type_code] = {
            r_type_code: item.r_type_code,
           
            r_type_name: item.get_room_name?.r_type_name, // Eğer varsa oda adını al
        };
    }
    const date = new Date(item.price_date);
    const formattedDate = `${date.getDate()} ${getMonthName(date.getMonth())} ${date.getFullYear()}`;
    // per_price alanını tam sayıya yuvarla
    const roundedPerPrice = Math.round(parseFloat(item.per_price));
    groupedData[item.r_type_code][formattedDate] = roundedPerPrice;
    
}); 




const extractDates3 = (data) => {
  return [...new Set(data.map(item => {
      const date = new Date(item.price_date);
      return `${date.getDate()} ${getMonthName(date.getMonth())} ${date.getFullYear()}`;
  }))];
};

const groupedData3 = {};

tblContPerPrice.forEach(item => {
    const { r_type_code,r_type_name, adult, child, price_date, per_price, currency } = item;

    const key = `${r_type_code}_${adult}_${child}`;

    if (!groupedData3[key]) {
        groupedData3[key] = {
            r_type_code: r_type_code,
            r_type_name: item.get_room_name?.r_type_name,
            adult: adult,
            child: child,
            currency: currency,
            prices: {} // Tarih bazında fiyat bilgilerini saklamak için bir nesne oluştur
        };
    }
    const date = new Date(item.price_date);
    const formattedDate = `${date.getDate()} ${getMonthName(date.getMonth())} ${date.getFullYear()}`;

  //  const formattedDate = price_date; // Tarih formatını değiştirmeden doğrudan kullanim
    const roundedPerPrice = Math.round(parseFloat(per_price));
    groupedData3[key].prices[formattedDate] = roundedPerPrice;
});

const groupedData33 = {};

tblContPerPrice.forEach(item => {
    const { r_type_code,r_type_name, adult, child, price_date, base_price, per_price, currency } = item;

    const key = `${r_type_code}_${adult}_${child}`;

    if (!groupedData33[key]) {
      groupedData33[key] = {
            r_type_code: r_type_code,
            r_type_name: item.get_room_name?.r_type_name,
            adult: adult,
            child: child,
            currency: currency,
            
            prices: {} // Tarih bazında fiyat bilgilerini saklamak için bir nesne oluştur
        };
    }
    const date = new Date(item.price_date);
    const formattedDate = `${date.getDate()} ${getMonthName(date.getMonth())} ${date.getFullYear()}`;

  //  const formattedDate = price_date; // Tarih formatını değiştirmeden doğrudan kullanim
    const roundedPerPrice = Math.round(parseFloat(base_price));
    groupedData33[key].prices[formattedDate] = roundedPerPrice;
});




const groupedData2 = {};
tblContPerPrice.forEach(item => {
    if (!groupedData2[item.r_type_code]) {
        // Eğer gruplanmış veri yoksa yeni bir grup oluştur
        groupedData2[item.r_type_code] = {
            r_type_code: item.r_type_code
        };
    }
    const date = new Date(item.price_date);
    const formattedDate = `${date.getDate()} ${getMonthName(date.getMonth())} ${date.getFullYear()}`;
    // per_price alanını tam sayıya yuvarla
    const roundedPerPrice = Math.round(parseFloat(item.per_price));
    if (!groupedData2[item.r_type_code][formattedDate]) {
        groupedData2[item.r_type_code][formattedDate] = {
            per_price: roundedPerPrice,
            adult: item.adult,
            child: item.child
        };
    } else {
        groupedData2[item.r_type_code][formattedDate].per_price = roundedPerPrice;
        groupedData2[item.r_type_code][formattedDate].adult = item.adult;
        groupedData2[item.r_type_code][formattedDate].child = item.child;
    }
});


/*
basamaklari yuvarla
const groupedData = {};
tblContPerPrice.forEach(item => {
    if (!groupedData[item.r_type_code]) {
        groupedData[item.r_type_code] = { r_type_code: item.r_type_code };
    }
    const date = new Date(item.price_date);
    const formattedDate = `${date.getDate()} ${getMonthName(date.getMonth())} ${date.getFullYear()}`;
    // per_price alanını belirli bir basamakta yuvarla
    let roundedPerPrice = parseFloat(item.per_price);
    if (roundedPerPrice > 1000) {
        roundedPerPrice = Math.round(roundedPerPrice / 100) * 100;
    }
    groupedData[item.r_type_code][formattedDate] = roundedPerPrice;

    const groupedData = {};
tblContPerPrice.forEach(item => {
    if (!groupedData[item.r_type_code]) {
        groupedData[item.r_type_code] = { r_type_code: item.r_type_code };
    }
    const date = new Date(item.price_date);
    const formattedDate = `${date.getDate()} ${getMonthName(date.getMonth())} ${date.getFullYear()}`;
    // per_price alanını belirli bir basamakta yuvarla
    let roundedPerPrice = parseFloat(item.per_price);
    if (roundedPerPrice > 1000) {
        roundedPerPrice = Math.round(roundedPerPrice / 1000) * 1000;
    }
    groupedData[item.r_type_code][formattedDate] = roundedPerPrice;
});

}); */


 
  
    // Header'ı oluştur
    const header = (
      <thead>
        <tr>
          <th>ROOM c TYPE</th>
          {dates.map(date => (
            <th key={date}>{date}</th>
          ))}
        </tr>
      </thead>
    );
  





  const handleBasePriceUpdate = () => {
    updateContBasePrice2({
      variables: {
        contIdSeq: contIdSeq,       
        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
        basePricePersent: basePricePersent,
        rTypeCodeSelect: rTypeCodeSelect,
        startDate: startDate,
        endDate: endDate,
       

       

        
      },
    })
      .then(() => {
        window.alert("Contract Base updated successfully!");
        refetch();
        refetchRuleSub();
        
      
       
      })
      .catch((error) => {
        console.error("Error updating Cont Base Price:", error);
      });
  };

 
  const [updateContBasePrice] = useMutation(UPDATE_BASE_PRICE);
  const [updateContBasePrice2] = useMutation(UPDATE_BASE_PRICE2);

  const [displayDialog2, setDisplayDialog2] = useState(false);
  const [loadingpop, setLoadingpop] = useState(false);
    
  
 const handleUpdate = async () => {
    try {
    refetch(); 
      refetchRuleSub();
      refetchRuleSub2();
      setDisplayDialog2(true);
      setLoadingpop(true);
      // Her bir satırı döngüye alarak güncelleme işlemi
      for (let i = 0; i < perRuleSubData2.tbl_cont_per_price.length; i++) {
        const row = perRuleSubData2.tbl_cont_per_price[i];
        const newPerPrice = calculateNewPerPrice(row.per_price, basePricePersent, row.person_factor, row.get_room_name.base_price_persent, row.week_rule_action_value, row.sepecial_day_action_value); //  bu parametreleri sirasi ile gonderiliyor unutma

        // Güncelleme mutasyonunu çağır
        const result = await updateContBasePrice({
          variables: {
            contIdSeq: row.cont_id,
            firmMainCode: row.firm_main_code,
            firmSubCode: row.firm_sub_code,
            basePricePersent: basePricePersent,
            rTypeCodeSelect: row.r_type_code,
            startDate: row.price_date,
            endDate: row.price_date,
            adl: row.adult,
            newPerPrice: newPerPrice,
            personFactor: row.person_factor,
          },
        });

       
      //  console.log("Result:", result);
      }
      setLoadingpop(false);
      setDisplayDialog2(false);
     
      refetch(); 
      refetchRuleSub();
      refetchRuleSub2();
      refetchRuleSub22();
      
    } catch (error) {
      console.error("Error updating rows:", error);
      console.log(error.message); 
    }
};// parametreleri sirasi ile aliyor unutma

const calculateNewPerPrice = (perPrice, basePricePersent, personFactor, roomBasePercent, week, special) => {
  const basePlusRoomPerson = (basePrice + (basePrice * roomBasePercent / 100)) * personFactor;
  const basePlusRoomTimesPerson = basePlusRoomPerson * week / 100;
  const basePlusRoomTimesPerson2 = basePlusRoomPerson * special / 100;
  const basePlusweektotal = basePlusRoomPerson + basePlusRoomTimesPerson;
  const basePlusspecialTotal = basePlusRoomPerson + basePlusRoomTimesPerson2;
  const basePlusspecial = basePlusweektotal + (basePlusweektotal * special / 100);
 


  if (basePrice === null) {
    // basePrice null ise, allPrice durumuna göre hesapla
    //allprice reduction or supplement
    if (allPrice) {
      return perPrice + (perPrice * basePricePersent / 100);
    } else {
      return perPrice - (perPrice * basePricePersent / 100);
    }
  } else if (basePricePersent === null) {
   
    // specialRule ve weekRule durumlarını kontrol et
    if (specialRule && weekRule) {
      // specialRule ve weekRule ikisi de true ise
      return basePlusspecial ;
    } else if (weekRule) {
      // sadece weekRule true ise
      //(basePrice + (basePrice * roomBasePercent / 100)) * personFactor + ((basePrice + (basePrice * roomBasePercent / 100)) * personFactor) * week / 100;
      return basePlusweektotal;
    } else if (specialRule) {
      // sadece specialRule true ise
      return basePlusspecialTotal;
    } else {
      // her ikisi de false ise
      return basePlusRoomPerson;
    }
  } else {
    // Her ikisi de null değilse, normal hesaplama yap
    return perPrice ;
  }
};

console.log(allPrice);

  const [batchUpdateContBasePrice] = useMutation(BATCH_UPDATE_CONT_BASE_PRICE);
  const [updateContBasePrices, { loading3, error3, data3 }] = useMutation(UPDATE_CONT_BASE_PRICES_MUTATION);

  const handleUpdate2 = async () => {
    try {
        setDisplayDialog2(true);
        setLoadingpop(true);

        // Gelen veriyi uygun formata dönüştürme
        const perRuleSubDataArray = perRuleSubData2.tbl_cont_per_price.map(item => item.per_price);

        if (Array.isArray(perRuleSubDataArray) && perRuleSubDataArray.length > 0) {
            const variables = {
                firmMainCode: perRuleSubData2.tbl_cont_per_price[0].firm_main_code,
                firmSubCode: perRuleSubData2.tbl_cont_per_price[0].firm_sub_code,
                contIdSeq: perRuleSubData2.tbl_cont_per_price[0].cont_id,
                rTypeCodeSelect: perRuleSubData2.tbl_cont_per_price[0].r_type_code,
                startDate: perRuleSubData2.tbl_cont_per_price[0].price_date,
                endDate: perRuleSubData2.tbl_cont_per_price[0].price_date,
                newPerPrice: perRuleSubDataArray,
            };

            const result = await updateContBasePrices({ variables });

            if (result.errors) {
                console.error("Mutasyon hataları:", result.errors);
                // Hataları uygun şekilde ele alın
            } else {
                if (result.data.updateContBasePrices.success) {
                    console.log("Güncelleme işlemi başarılı!");
                    console.log("Etkilenen satır sayısı:", result.data.updateContBasePrices.affected_rows);
                } else {
                    console.error("Güncelleme işlemi başarısız:", result.data.updateContBasePrices.message);
                }
            }
        } else {
            console.error("Veri uygun formatta değil: Dizi bekleniyordu");
        }

        setLoadingpop(false);
        setDisplayDialog2(false);

    } catch (error) {
        console.error("Bir hata oluştu:", error);
    }
};
  

   


  const handleBatchUpdate = async (basePricePersent) => {
    // Verinin hazır olmasını bekleyin
    if (loadingRuleSub2) {
      await new Promise((resolve) => setTimeout(resolve, 100)); // Gecikme süresini ihtiyacınıza göre ayarlayın
    }

    // Veri erişilebilirliğini kontrol edin
    if (!perRuleSubData2 || !perRuleSubData2.tbl_cont_per_price) {
      console.error("Veri güncelleme için hazır değil");
      return;
    }

    try {
      const updates = perRuleSubData2.tbl_cont_per_price.map((row) => ({
        _set: {
          per_price: calculateNewPerPrice(row.per_price, basePricePersent),
        },
        where: {
          firm_main_code: row.firm_main_code,
          firm_sub_code: row.firm_sub_code,
          cont_id: row.cont_id,
          r_type_code: row.r_type_code,
          adult: row.adult,
          price_date: row.price_date,
        },
      }));

      const result = await batchUpdateContBasePrice({
        variables: {
          updates: updates,
        },
      });



      console.log("Sonuç:", result);

      window.alert("Tüm satırlar başarıyla güncellendi!");
      refetch();
      refetchRuleSub();
      refetchRuleSub2();
    } catch (error) {
      console.error("Satırları güncellerken hata oluştu:", error);
      console.log(error.message);
    }
  };
  
  const calculateNewPerPrice2 = (perPrice, basePricePersent) => {
    const result = perPrice + (perPrice * basePricePersent / 100);
    return parseFloat(result.toFixed(2)); // İki ondalık basamağa yuvarla ve ardından float'a dönüştür
  };


  
    const onClickUpdate = () => {
      refetchRuleSub();
      refetchRuleSub2();
      handleUpdate();
    };
  


  


    

    useEffect(() => {
        if (firmData) {  

            setStartDate(new Date());
            setEndDate(new Date());
            setStartDate3(new Date());
            setEndDate3(new Date());
            
          setContIdSeq(varCode4);
       // setContIdSeq(firmData.cont_id);
          setContSeaIdSeq(firmData.id_seq);
          setHtlSeaIdSeq(firmData.rules_grp_id);
          setRulesGrpClass(firmData.rules_grp_class);

         
         
          refetch();  
          
    
        }
      }, [firmData]);



      useEffect(() => {
       
            
          refetcGetHtlRule();  
        
     
      }, [rulesGrpClass]);
    
     

      useEffect(() => {
        // varCode4 değiştiğinde yapılacak işlemler
        setContIdSeq(varCode4);
        setVarCode4(varCode4);
        setSomeCondition(true);
        console.log("var:", varCode4)
        
        // refetch fonksiyonunu çağırma koşullarına bağlı olarak
        if (someCondition) {
          refetch();
         
        }
      }, [varCode4, setContIdSeq, someCondition]);




  const getStatusLabel = (rowData) => {
    const statusClass = rowData.active
      ? "text-purple-800 font-bold text-sm"
      : "text-gray-500 font-bold text-sm";
  
    return (
      <div className={statusClass}>
      {rowData.active ? (
        <FormattedMessage id={activerec} />
      ) : (
        <FormattedMessage id={inactiverec} />
      )}
    </div>
    );
  };
      
      


          const [displayBasic, setDisplayBasic] = useState(false);

          const onClick = () => {
          //  setVarCode11(ruleType); //EBO
          //  setVarCode8(rulSubId);
         //   setDisplayBasic(true);
         handleUpdate();
            
          };

          const onHide = () => {
            setDisplayBasic(false);
            refetch();
            refetchRuleSub();
            
          };


          const [displayBasic2, setDisplayBasic2] = useState(false);

  

          const onHide2 = () => {
            refetcGetHtlRule();
            refetchRuleSub();
            setDisplayBasic2(false);
           
          };

     



  const htlRuleItems = htlRuleData && htlRuleData.tbl_htl_room_type
  ? htlRuleData.tbl_htl_room_type.map(item => ({
      label: item.r_type_name,
      value: item.r_type_code,
      name: item.r_type_name, 
    }))
  : [];

    
 

         
        const getCellClassName = (dateString, r_type_code) => {
    // Belirli bir tarih aralığında ve belirli bir r_type_code için hücre rengini değiştirme kurallarını burada uygulayabilirsiniz
    const startDateObj = new Date(startDate);
    startDateObj.setDate(startDateObj.getDate() - 1);
    const endDateObj = new Date(endDate).toLocaleString('en-GB');
    const dateObj = new Date(dateString);
   
   
    
  

    const formattedStartDate = startDateObj.toLocaleString('en-GB');
    const formattedEndDate = endDateObj.toLocaleString('en-GB');
    const formattedDate = dateObj.toLocaleString('en-GB');

    // Örneğin, sadece r_type_code 'FAR' olan hücreleri mavi olarak işaretleyelim
    if (r_type_code === rTypeCodeSelect && formattedDate >= formattedStartDate && formattedDate <= formattedEndDate) {
        return 'custom-cell-blue';
    }
    // Başka bir tarih aralığı ve/veya r_type_code için farklı bir sınıf belirleyebilirsiniz
    // if (r_type_code === 'BAŞKA_TÜR' && date >= new Date('2024-01-11'.toLocaleString('tr-TR')) && date <= new Date('2024-01-20'.toLocaleString('tr-TR'))) {
    //     return 'custom-cell-green';
    // }
    // Belirli bir tarih aralığında veya r_type_code'da renk değiştirmek istemiyorsanız boş bir dize döndürebilirsiniz
    return '';
};
const getCellClassName2 = (dateString, startDate, endDate) => {
    const startDateObj = new Date('2023-11-08');
    const endDateObj = new Date('2024-11-14');
    const dateObj = new Date(dateString);

    const formattedStartDate = startDateObj.toLocaleDateString('en-GB');
    const formattedEndDate = endDateObj.toLocaleDateString('en-GB');
    const formattedDate = dateObj.toLocaleDateString('en-GB');

    if (formattedDate >= formattedStartDate && formattedDate <= formattedEndDate) {
        return 'custom-cell-blue';
    }
    return '';
};

const rowClass = (r_type_code) => {
    return {
        'bg-primary': r_type_code === 'FAR'
    };
};


const getCellClassName3 = (dateString) => {
    const currentDate = new Date(dateString);
    const startDate = new Date('01-01-2024'); // Başlangıç tarihi
    const endDate = new Date('15-01-2024'); // Bitiş tarihi

    if (currentDate >= startDate && currentDate <= endDate) {
        return 'custom-cell-blue'; // Belirtilen tarih aralığına dahilse 'custom-cell-blue' sınıfını döndürür
    } else {
        return ''; // Dahil değilse boş bir string döndürür
    }
};


const getCellBackgroundColor = (date) => {
  //  const startDate = new Date('2023-11-08'); // Başlangıç tarihi
    //const endDate = new Date('2024-01-12'); // Bitiş tarihi

    const startDate2 = new Date(startDate); // Başlangıç tarihi
    const endDate2 = new Date(endDate); // Bitiş tarihi
    const currentDate = new Date(date);

    // Tarih aralığı kontrolü
    if (currentDate >= startDate && currentDate <= endDate) {
        return 'rgb(221 212 222 / var(--tw-bg-opacity)'; // Light Blue rengi, 50% opaklık
    }
    return ''; // Tarih aralığına dahil değilse boş bir string döndürülecek
};

const getCellBackgroundColor2 = (date, rTypeCode) => {
    const startDate2 = new Date(startDate); // Başlangıç tarihi
    const endDate2 = new Date(endDate); // Bitiş tarihi
    const currentDate = new Date(date);

    // Tarih aralığı ve r_type_code kontrolü
    if (allRoom) {
      // Tüm oda tipleri için kontrol yap
      if (currentDate >= startDate2 && currentDate <= endDate2) {
          return 'rgb(221 212 222 / var(--tw-bg-opacity)'; // Light Blue rengi, 50% opaklık
      }
  } else {
      // Belirli bir oda tipi için kontrol yap
      if (currentDate >= startDate2 && currentDate <= endDate2 && rTypeCode === rTypeCodeSelect) {
          return 'rgb(221 212 222 / var(--tw-bg-opacity)'; // Light Blue rengi, 50% opaklık
      }
  }
};

const [selectedRowData, setSelectedRowData] = useState(null);
const [selectedCellData, setSelectedCellData] = useState(null);

// Olay işleyicisi tanımla
const onSelectionChange = (e) => {
    setSelectedRowData(e.value); // Seçilen satırın verilerini sakla
    console.log("Selected Row Data:", e.value); // Verileri konsola yazdır
};

const onCellSelect = (e, roomType, date) => {
  const rowData = e.data; // Seçilen hücrenin verilerini al
  const roomTypeCode = e.room_type_code // Oda tipi kodunu al
  const selectedDate = e.field; // Seçilen hücrenin tarihini al
  console.log("Selected Room Type Code:", roomTypeCode); // Oda tipi kodunu konsola yazdır
  console.log("Selected Date:", selectedDate); // Seçilen tarihi konsola yazdır
  console.log("Room Type:", roomType); // ROOM TYPE'i konsola yazdır
  console.log("Date:", date);
  console.log("Adult:", e.adult); // Tarihi konsola yazdır
  console.log("child:", e.child);
  console.log("child:", e.currency);
  console.log("child:", e.red_id);
  setRTypeCodeQ(roomType);
  setDetailDateQ(date)
  setDetailAdultQ(e.adult);
};

  
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

   
  
    return (

        
        <>
        <div className="grid grid-cols-8 gap-2">
  <div className="col-span-6">
    {/* İkinci sütunun ilk bloğu */}
    <div className="mr-2">
      {/* İçerik buraya gelecek */}
     
      <Fieldset>

<div>

<Dialog visible={displayBasic2} style={{ width: '70vw' }} onHide={onHide2} header={"Rules Group"}>
<div className={`modal-backdrop bg-slate-600  ${displayBasic2 ? 'block' : 'hidden'}`}></div>
<div>
<p>
<HtlAgnOffresGrp/> 
</p>
</div>
</Dialog>
</div>




  <div className="flex">
    <div className="mr-2 w-1/8">
      <label htmlFor="firmType" className="block font-medium text-gray-700">
        {"Cont Id"}
      </label>
      <InputNumber
        inputId="integeronly"
        useGrouping={false}
        value={contIdSeq}
        onValueChange={(e) => setContIdSeq(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        readOnly
      />                
    </div>

  
    <div className="mr-2 w-1/8">
      <label htmlFor="firmType" className="block font-medium text-gray-700">
        {"Cont Season Id"}
      </label>
      <InputNumber
        inputId="integeronly"
        useGrouping={false}
        value={contSeaIdSeq}
        onValueChange={(e) => setContSeaIdSeq(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        readOnly
      />                
    </div>

    <div className="w-1/8 h-10 gap-3">
        <label                
         htmlFor="firmname"> {"Start Date"}</label>
        <Calendar className="w-full h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={startDate3} dateFormat="dd/mm/yy"
        onChange={(e) => setStartDate3(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>
      <br></br>
      

      <div className="w-1/8 top-10 gap-3">
        <label                
         htmlFor="firmname"> {"End Date"}</label>
        <Calendar className="w-1/8 h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={endDate3} dateFormat="dd/mm/yy"
        onChange={(e) => setEndDate3(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>



   


  </div>
  
  
  






</Fieldset>

<TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
 <TabPanel   header={
  <span
    className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
      activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
      
    }`}
  >
    {" Price Plan"}
  </span>
}
className="ml-5 flex"
>
  

<div>
<style>
        {`
          .custom-cell-blue {
           
            background-color: rgb(221 212 232 / var(--tw-bg-opacity));
          }
        `}
      </style>

      <DataTable
  frozenHeader
  scrollable
  showGridlines
  scrollHeight="400px"
  size="small"
  tableStyle={{ minWidth: '80rem' }}
  value={Object.values(groupedData11)}
  cellSelection={true}
  
  
>
  <Column field="r_type_code" header="ROOM TYPE" style={{ width: '20em', minWidth: '8em' }} frozen />
  <Column field="r_type_name" header="ROOM NAME" style={{ width: '20em', minWidth: '15em' }} frozen />
  {dates.map(date => {
    const dateObject = new Date(date);
    const day = dateObject.getDate();
    let month = '';
    if (currentLocale === 'tr') {
      month = getMonthNameEN(dateObject.getMonth());
    } else if (currentLocale === 'en') {
      month = getMonthNameEN(dateObject.getMonth());
    } else if (currentLocale === 'ru') {
      month = getMonthNameEN(dateObject.getMonth());
    }
    const formattedHeader = `${day} ${month}`;
    return (
      <Column
        key={date}
        header={formattedHeader} // Gün ve ay bilgilerini birleştirerek başlığı güncelle
        style={{ width: '10em', minWidth: '5em' }}
        field={date}
        
        body={(rowData) => {
          const priceData = rowData.hasOwnProperty(date) ? rowData[date] : '-';
          const rTypeCode = rowData.r_type_code || '';
          const cellStyle = {
            backgroundColor: getCellBackgroundColor2(date, rTypeCode)
          };
          return (
            <div 
              style={{...cellStyle, cursor: 'pointer'}}
              onClick={() => onCellSelect(rowData, rTypeCode, date)} 
            >
              {priceData}
            </div>
          );
        }}
      />
    );
  })}
</DataTable>
    <br></br><br></br>


</div>

    </TabPanel>
  

    <TabPanel   header={
  <span
    className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
      activeTab === 2 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
      
    }`}
  >
    {"Price Detail"}
  </span>
}
className="ml-5 flex"
>

<DataTable
    frozenHeader
    scrollable
    showGridlines
    scrollHeight="400px"
    size="small"
    tableStyle={{ minWidth: '80rem' }}
    value={Object.values(groupedData3)}
    rowGroupMode="rowspan" groupRowsBy="r_type_name" 
    cellSelection={true}
    
    
>
    <Column field="r_type_code" header="ROOM TYPE" style={{ width: '8em', minWidth: '8em',  maxWidth: '8em' }} frozen />
    <Column field="r_type_name" header="ROOM NAME" style={{ width: '15em', minWidth: '15em' ,  maxWidth: '15em'}} frozen  className="font-bold" />
    <Column field="adult" header="ADULT" style={{ width: '6em', minWidth: '6em',  maxWidth: '6em' }} />
    <Column field="child" header="CHILD" style={{ width: '6em', minWidth: '6em',  maxWidth: '6em' }} />
    {Object.values(groupedData3).length > 0 && Object.keys(groupedData3[Object.keys(groupedData3)[0]].prices).map(date => (
        <Column
            key={date}
            header={() => {
              const dateObject = new Date(date);
              const day = dateObject.getDate();
              let month = '';
              if (currentLocale === 'tr') {
                month = getMonthNameTR(dateObject.getMonth());
              } else if (currentLocale === 'en') {
                month = getMonthNameEN(dateObject.getMonth());
              } else if (currentLocale === 'ru') {
                month = getMonthNameEN(dateObject.getMonth());
              }
              return `${day} ${month}`;
            }}
            style={{ width: '10em', minWidth: '5em' }}
            body={(rowData) => {
                const priceData = rowData.prices[date] || '-'; // Tarih için fiyat bilgisini al, eğer veri yoksa '-' göster
                const rTypeCode = rowData.r_type_code || ''; // r_type_code'u alır, eğer yoksa boş bir string olarak ayarlar
                const cellStyle = {
                    backgroundColor: getCellBackgroundColor2(date, rTypeCode)
                };
                return (
                  <div 
                  style={{...cellStyle, cursor: 'pointer'}}
                  onClick={() => onCellSelect(rowData, rTypeCode, date)} 
                >
                  {priceData}
                </div>
                );
            }}
        />
    ))}
</DataTable>


<div className="flex grid-cols-6 mt-5 mb-2 gap-2">

<div className="mr-2 w-1/1">
    
    <label htmlFor="firmType" className="block font-medium text-gray-700">
          {"Room "}
        </label>
        
         <InputText
         // detail block info start
          inputId="integeronly"
          useGrouping={false}
          value={rTypeCode}
          onValueChange={(e) => setRTypeCodeQ(e.value)}
          className="w-full h-11 border-gray-300 rounded-md"
          
        />               
    </div>

<div className="w-1/1 h-10 gap-3">
        <label                
         htmlFor="firmname"> {"Start Date"}</label>
        <Calendar className="w-full h-11" 
    //    inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
     //   style={{ width:"%80" }}    
        id="firmname" value={detalilDate}
        dateFormat="dd/mm/yy"
        onChange={(e) => setDetailDate(e.target.value)} 
        
        locale="tr"/>
      </div>

      <div className="mr-2 w-1/1">
    
  <label htmlFor="firmType" className="block font-medium text-gray-700">
        {"Adult "}
      </label>
      
       <InputText
       // detail block info start
        inputId="integeronly"
        useGrouping={false}
        value={detailAdult}
        onValueChange={(e) => setDetailAdult(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        
      />               
  </div>
  <div className="mr-2 w-1/1">
      <label htmlFor="firmType" className="block font-medium text-gray-700">
        {"Child "}
      </label>
       <InputText
        inputId="integeronly"
        useGrouping={false}
        value={detailChild}
        onValueChange={(e) => setDetailAdult(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        
      />               
    </div>

    <div className="mr-2 w-1/1">
      <label htmlFor="firmType" className="block font-medium text-gray-700">
        {"Dynamic Price "}
      </label>
       <InputNumber
        inputId="integeronly"
        useGrouping={false}
        value={detailPrice}
        onValueChange={(e) => setDetailPrice(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        
      />               
    </div>


    <div className="mr-2 w-1/1">
      <label htmlFor="firmType" className="block font-medium text-gray-700">
        {"Base Price "}
      </label>
       <InputNumber
        inputId="integeronly"
        useGrouping={false}
        value={detailBasePrice}
        onValueChange={(e) => setDetailBasePrice(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        
      />               
    </div>

    <div className="w-20 p-inputtext-sm flex-column gap-3">
        <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="firmname"> {'Currency'}</label>
        <InputText className="w-full h-11" 
        id="firmname" value={detailCurrency} 
        onChange={(e) => setDetailCurrency(e.target.value)} />
      </div>

    

  {/* Diğer inputlar da aynı şekilde devam eder */}
</div>


<div className="grid grid-cols-8 gap-2">
 
<div className="w-28 p-inputtext-sm flex-column gap-3">
        <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="firmname"> {'Room Factor'}</label>
        <InputText className="w-full h-11" 
        id="firmname" value={detailRoomFactor} 
        onChange={(e) => setDetailRoomFactor(e.target.value)} />
      </div>

      <div className="w-28 p-inputtext-sm flex-column gap-3">
        <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="firmname"> {'Person Factor'}</label>
        <InputText className="w-full h-11" 
        id="firmname" value={detailPersonFactor} 
        onChange={(e) => setPersonFactor(e.target.value)} />
      </div>

      <div className="w-28 p-inputtext-sm flex-column gap-3">
        <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="firmname"> {'Week Day'}</label>
        <InputText className="w-full h-11" 
        id="firmname" value={detailWeekFactor} 
        onChange={(e) => setDetailWeekFactor(e.target.value)} />
      </div>

      <div className="w-28 p-inputtext-sm flex-column gap-3">
        <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="firmname"> {'Special Day'}</label>
        <InputText className="w-full h-11" 
        id="firmname" value={detaiSlpecialFactor} 
        onChange={(e) => setdetailSpecialFactor(e.target.value)} />
      </div>

      <div className="w-28 p-inputtext-sm flex-column gap-3">
        <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="firmname"> {'Dynamic Price'}</label>
        <InputText className="w-full h-11" 
        id="firmname" value={detailDynFactor} 
        onChange={(e) => setDetailDynFactor(e.target.value)} />
      </div>
    

    

  {/* Diğer inputlar da aynı şekilde devam eder */}
</div>

  

    </TabPanel>

   
  
</TabView>
      
    </div>
  </div>
  <div className="col-span-2">
    {/* İkinci sütunun ikinci bloğu */}
    <div className="mr-2">
      {/* İçerik buraya gelecek */}
     
      <Fieldset>



  <div className="">
    <div className="mr-2 w-1/1">
    <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {"Room Type"}
       </label>
       <Dropdown
       className="h-11 w-48 rounded-md" 
       //style={{ width: '284px' }} 
       
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={rTypeCodeSelect}
         options={htlRuleItems}
         onChange={(e) => setRTypeCodeSelect(e.value)}
         placeholder={"select_a_room_type"}
         />
    </div>

    

  
  



</div>




</Fieldset>

<Fieldset>

<div>

<Dialog visible={displayBasic2} style={{ width: '70vw' }} onHide={onHide2} header={"Rules Group"}>
<div className={`modal-backdrop bg-slate-600  ${displayBasic2 ? 'block' : 'hidden'}`}></div>
<div>
<p>
<HtlAgnOffresGrp/> 
</p>
</div>
</Dialog>
</div>




  <div className="">

  <div className="flex items-center">
  <div className="mr-2 w-1/2">
    <label htmlFor="firmType" className="block font-medium text-gray-700"> 
      {"All Room"}
    </label>
    <InputSwitch checked={allRoom} onChange={(e) => setAllRoom(e.value)} />
  </div> 
  
  <div className="mr-2 w-1/2">
    <label htmlFor="firmType" className="block font-medium text-gray-700"> 
      {"Supplement "}
    </label>
    <InputSwitch checked={allPrice} onChange={(e) => setAllPrice(e.value)} />
  </div>
</div>

<div className="flex items-center">
  <div className="mr-2 w-1/2">
    <label htmlFor="firmType" className="block font-medium text-gray-700"> 
      {"Re Week Days"}
    </label>
    <InputSwitch checked={weekRule} onChange={(e) => setWeekRole(e.value)} />
  </div> 
  <div className="mr-2 w-1/2">
    <label htmlFor="firmType" className="block font-medium text-gray-700"> 
      {"Special Days "}
    </label>
    <InputSwitch checked={specialRule} onChange={(e) => setSpecialRole(e.value)} />
  </div>
</div>





     <div className="mr-2 w-1/1">
      <label htmlFor="firmType" className="block font-medium text-gray-700">
        {"Base Price "}
      </label>
       <InputNumber
        inputId="integeronly"
        useGrouping={false}
        value={basePrice}
        onValueChange={(e) => setBasePrice(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        
      />               
    </div>

    

  
    <div className="mr-2 w-1/1">
      <label htmlFor="firmType" className="block font-medium text-gray-700">
        {"Base Price %"}
      </label>
       <InputNumber
        inputId="integeronly"
        useGrouping={false}
        value={basePricePersent}
        onValueChange={(e) => setBasePricePersent(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        
      />               
    </div>

   


    <div className="w-1/1 h-10 gap-3">
        <label                
         htmlFor="firmname"> {"Start Date"}</label>
        <Calendar className="w-full h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={startDate}
        dateFormat="dd/mm/yy"
        onChange={(e) => setStartDate(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>
      <br></br>
      

      <div className="w-1/1 top-10 gap-3">
        <label                
         htmlFor="firmname"> {"End Date"}</label>
        <Calendar className="w-1/8 h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={endDate} 
        dateFormat="dd/mm/yy"
        onChange={(e) => setEndDate(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>

    


<button
className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
onClick={onClick}
>
{"Update"}
</button>

<Dialog
                header="Update Records"
                visible={displayDialog2}
                style={{ width: '30vw' }}
                onHide={() => setDisplayDialog2(false)}
            >
                {loadingpop ? (
                    <div style={{ textAlign: 'center' }}>
                        <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" animationDuration=".5s" />
                    </div>
                ) : (
                    <div>Records Update successfully.</div>
                )}
            </Dialog>



</div>




</Fieldset>


    </div>
  </div>
</div>
 <div>
 ddd
</div>
          
        </>
      );
      
  };
  
  export default HtlSalesPlanCalc;


  /*


  <div className="mr-2 w-1/1">
  
      <label htmlFor="firmType" className="block font-medium text-gray-700">
        {"Adult "}
      </label>
      
       <InputNumber
       // detail block info start
        inputId="integeronly"
        useGrouping={false}
        value={detailAdult}
        onValueChange={(e) => setDetailAdult(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        
      />               
    </div>

    <div className="mr-2 w-1/1">
      <label htmlFor="firmType" className="block font-medium text-gray-700">
        {"Adult "}
      </label>
       <InputNumber
        inputId="integeronly"
        useGrouping={false}
        value={detailChild}
        onValueChange={(e) => setDetailAdult(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        
      />               
    </div>


<div className="mr-2 w-1/1">
      <label htmlFor="firmType" className="block font-medium text-gray-700">
        {"Dynamic Price "}
      </label>
       <InputNumber
        inputId="integeronly"
        useGrouping={false}
        value={detailPrice}
        onValueChange={(e) => setDetailPrice(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        
      />               
    </div>

    <div className="mr-2 w-1/1">
      <label htmlFor="firmType" className="block font-medium text-gray-700">
        {"Base Price "}
      </label>
       <InputNumber
        inputId="integeronly"
        useGrouping={false}
        value={detailBasePrice}
        onValueChange={(e) => setDetailBasePrice(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        
      />               
    </div>


    <div className="w-20 p-inputtext-sm flex-column gap-3">
        <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="firmname"> {'Currency'}</label>
        <InputText className="w-full h-11" 
        id="firmname" value={detailCurrency} 
        onChange={(e) => setDetailCurrency(e.target.value)} />
      </div>

      <div className="w-28 p-inputtext-sm flex-column gap-3">
        <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="firmname"> {'Room Factor'}</label>
        <InputText className="w-full h-11" 
        id="firmname" value={detailRoomFactor} 
        onChange={(e) => setDetailRoomFactor(e.target.value)} />
      </div>

      <div className="w-28 p-inputtext-sm flex-column gap-3">
        <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="firmname"> {'Person Factor'}</label>
        <InputText className="w-full h-11" 
        id="firmname" value={detailPersonFactor} 
        onChange={(e) => setPersonFactor(e.target.value)} />
      </div>

      <div className="w-28 p-inputtext-sm flex-column gap-3">
        <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="firmname"> {'Week Day'}</label>
        <InputText className="w-full h-11" 
        id="firmname" value={detailWeekFactor} 
        onChange={(e) => setDetailWeekFactor(e.target.value)} />
      </div>

      <div className="w-28 p-inputtext-sm flex-column gap-3">
        <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="firmname"> {'Special Day'}</label>
        <InputText className="w-full h-11" 
        id="firmname" value={detaiSlpecialFactor} 
        onChange={(e) => setdetailSpecialFactor(e.target.value)} />
      </div>

      <div className="w-28 p-inputtext-sm flex-column gap-3">
        <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="firmname"> {'Dynamic Price'}</label>
        <InputText className="w-full h-11" 
        id="firmname" value={detailDynFactor} 
        onChange={(e) => setDetailDynFactor(e.target.value)} />
      </div>


    <div className="w-1/1 h-10 gap-3">
        <label                
         htmlFor="firmname"> {"Start Date"}</label>
        <Calendar className="w-full h-11" 
    //    inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
     //   style={{ width:"%80" }}    
        id="firmname" value={detalilDate}
        dateFormat="dd/mm/yy"
        onChange={(e) => setDetailDate(e.target.value)} 
        
        locale="tr"/>
      </div>




<DataTable
value={firmData2}
scrollable 
scrollHeight="250px" 
loading={loadingRuleSub}
stickyHeader
stickyTopAt=".layout-topbar"


>
 <Column field="cont_id"
 className="text-xs text-right" 
 header={<span className="font-bold text-gray-900">{"Rule Id"}</span>}
 style={{ textAlign: 'left', width: '7rem' }}
>
</Column>


<Column field="rules_sub_type"
 className="text-xs text-right" 
 header={<span className="font-bold text-gray-900">{"Rules Type"}</span>}
 style={{ textAlign: 'left', width: '9rem' }}
>
</Column>
<Column field="rules_sub_name"
 className="text-xs text-right" 
 header={<span className="font-bold text-gray-900">{"Rules Desc"}</span>}
 style={{ textAlign: 'left', width: '15rem' }}
>
</Column>

<Column
 field="start_date"
 header={<span className="font-bold text-sm text-gray-900">{"start_date_title"}</span>}
 body={(rowData) => {
 const dateTimeString = rowData.start_date;
 const dateObj = new Date(dateTimeString);
 const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
 const formattedDate = `${dateObj.toLocaleDateString('en-GB', options)} `;
 

return (
 <div className="text-sm">
 {formattedDate}
 </div>
  );
 }}
style={{ textAlign: 'left', width: '10rem' }}
 />


<Column
 field="end_date"
 header={<span className="font-bold text-sm text-gray-900">{"end_date_title"}</span>}
 body={(rowData) => {
 const dateTimeString = rowData.end_date;
 const dateObj = new Date(dateTimeString);
 const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
 const formattedDate = `${dateObj.toLocaleDateString('en-GB', options)} `;
 // const createUser = rowData.end_date;

return (
 <div className="text-sm">
 {formattedDate}
 </div>
  );
 }}
style={{ textAlign: 'left', width: '10rem' }}
 />

<Column
  field="active"
  body={getStatusLabel}
  header={<span className="font-bold text-gray-900">{"statusrec"}</span>}
  style={{ textAlign: 'center', width: '6rem' }}
  className="font-bold text-sm" 
/>
<Column
header={<span className="font-bold text-sm text-gray-900">{"detail"}</span>}
body={(rowData) => (
  <button
    onClick={() => {               
  //    setVarCode8(rowData.id_seq);  
      setVarCode(rowData.r_prn_id_seq);     
    //  setVarCode10(rowData.id_seq);   
      
      setVarCode11(rowData.rules_sub_type); //EBO
      setVarCode8(rowData.id_seq);
      setVarCode9("COFF")
      onClick();
    
      
    }}
    className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
  >
    <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
      <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
    </svg>
  </button>
)}
style={{ textAlign: 'center', width: '6rem' }}
></Column>

</DataTable>


<Dialog header={"Contract Offers Detail"} visible={displayBasic} style={{ width: '55vw' }} onHide={onHide}>

<div>

<HtlAgnOffresEdit/>


</div>

</Dialog> */
 


      
  